// extracted by mini-css-extract-plugin
export default {"wrapper":"SportsCategoriesMenu_wrapper--_X5","title":"SportsCategoriesMenu_title--ijT"};